import { ReCaptchaProvider } from "utils/reCaptcha"
import AuthReCaptchaView from "common/layouts/application/AuthReCaptchaView"
import Provider from "./hooks"

const formName = "signIn"
export default function SignIn() {
  return (
    <AuthReCaptchaView pageName="サインイン">
      <ReCaptchaProvider formName={formName}>
        <Provider />
      </ReCaptchaProvider>
    </AuthReCaptchaView>
  )
}
